import React from 'react'
import { Button, Flex, Select, Text } from 'theme-ui'
import { experiments, useExperiment } from '~/hooks/utils/use-experiment'

export const AddToCartProductListVariants = ({
  setVariantSelected,
  variantSelected,
  allVariantOptions,
  label,
  isSelect,
  sx,
  variants,
  variantsAvailable,
}) => {
  const handleVariantSelected = event => {
    const { value } = event.target
    const v = allVariantOptions.find(v => v.slug === value)

    setVariantSelected(prev => ({
      ...prev,
      [v.option_type[0].slug]: v.slug,
    }))
  }

  let defaultValue = null

  if (variants) {
    defaultValue = variants[0].optionValues.find(
      opt => opt.presentation === allVariantOptions[0].presentation,
    )
  }

  const collectionsCardsTest = useExperiment(experiments.newProductCardLayout)

  const isShopAll =
    typeof window !== 'undefined'
      ? !new URLSearchParams(location.search).get('collection')
      : false

  return (
    <Flex
      sx={{
        gap: '5px',
        alignItems: 'center',
        /*justifyContent: collectionsCardsTest ? 'center' : 'space-between',*/
        justifyContent: 'center',
        /*flexWrap: collectionsCardsTest && 'wrap',*/
        flexWrap: 'wrap',
        flexGrow: '1',
        // flexDirection: 'column',
        ...sx,
        svg: {
          color: isShopAll ? 'secondary' : 'primary',
        },
      }}
    >
      <Text
        as="span"
        sx={{
          fontWeight: '900',
          /*fontSize: collectionsCardsTest ? ['16px'] : ['12px', '18px'],*/
          fontSize: ['16px'],
          /*lineHeight: collectionsCardsTest ? '16px' : 'initial',*/
          lineHeight: '16px',
          textTransform: 'capitalize',
          /*maxWidth: collectionsCardsTest ? '40px' : 'initial',*/
          maxWidth: '4rem',
          mr: [0, 0, '1rem'],
        }}
      >
        {label === 'merch-size' ? 'size' : label}
      </Text>

      {isSelect ? (
        <Select
          defaultValue={defaultValue.presentation}
          onChange={handleVariantSelected}
          sx={{
            border: 'solid 1px',
            borderColor: 'primary',
            marginLeft: ['0px', '10px'],
            marginRight: '3px',
            color: isShopAll ? 'secondary' : 'primary',
            padding: ['0px 20px 0px 8px', '0px 30px 0px 8px'],
            width: '100%',
            maxHeight: '40px',
            height: '40px',
            maxWidth: '100%',
          }}
        >
          {allVariantOptions?.map(v => {
            const disable = variantsAvailable.some(({ optionValues }) =>
              optionValues.some(opt => opt.slug === v.slug),
            )

            return (
              <option key={v?.presentation} disabled={!disable} value={v?.slug}>
                {v?.presentation}
              </option>
            )
          })}
        </Select>
      ) : (
        <Flex
          sx={{
            gap: '5px',
            justifyContent: 'center',
          }}
        >
          {allVariantOptions.map(v => (
            <Button
              sx={{
                display: 'grid',
                placeContent: 'center',
                /*height: collectionsCardsTest ? '34px' : '40px',*/
                height: '34px',
                /*minHeight: collectionsCardsTest ? '34px' : '40px',*/
                minHeight: '34px',
                /*width: collectionsCardsTest ? '40px' : '40px',*/
                width: '40px',
                /*minWidth: collectionsCardsTest ? '40px' : '40px',*/
                minWidth: '40px',
                padding: '0px',
                fontSize: '16px',
                fontFamily: 'Sofia-Regular',
                backgroundColor: collectionsCardsTest
                  ? v?.slug === variantSelected[v.option_type[0].slug]
                    ? 'red'
                    : 'transparent'
                  : 'transparent',
                color: collectionsCardsTest
                  ? v?.slug === variantSelected[v.option_type[0].slug]
                    ? 'white'
                    : 'primary'
                  : 'primary',
                border: collectionsCardsTest
                  ? 'solid 2px'
                  : v?.slug === variantSelected[v.option_type[0].slug] &&
                    'solid 2px',
                borderColor: 'primary',
                ':hover': {
                  borderColor: 'primary',
                  color: 'primary',
                },
              }}
              name="subscription-type"
              value={v?.slug}
              onClick={handleVariantSelected}
              key={v.slug}
            >
              {v?.presentation}
            </Button>
          ))}
        </Flex>
      )}
    </Flex>
  )
}
